import * as actions from '../actions/currentRoleActionTypes';


const initialState = {    
  roleWater: 0,
  roleTime: 0,
  roleTimeTemp: 0,
  roleTimeAdmin: 0,
  roleCustSupp: 0,
  roleCustSuppAdmin: 0,
  roleEmp: 0,
  roleEmpTl: 0,
  roleEmpAdmin: 0,
  roleEmpData: 0,
  roleAuditing: 0,
  roleAuditingAdmin: 0,
  roleFraObObserver: 0,
  roleAdmin: 0,
  roleSuperuser: 0,
  roleNoFraRole: 0,
  roleNoCsRole: 0,
  roleDbReplicator: 0,
  roleDbReplicatorAdmin: 0,
  roleNoCompRole: 0,
  roleCustSuppStatistics: 0,
  roleTransparencyAdmin: 0,
  roleTransparency: 0,
  roleDatamanager: 0,
  roleDatamanagerAdmin: 0,
  roleClearingAdmin: 0,
  roleClearing: 0,
  roleClearingSdiAdmin: 0,
  roleClearingSdi: 0,
  roleFraOperator: 0,
  roleFraObAdmin: 0,
  roleConservationAdmin: 0
}


function currentRoles(state = initialState, action) {      
  switch (action.type) {    
    case actions.ROLE_WATER:
      return {
        ...state, 
        roleWater: action.roleWater
      }
    case actions.ROLE_TIME:
      return {
        ...state, 
        roleTime: action.roleTime
      }
    case actions.ROLE_TIME_TEMP:
      return {
        ...state, 
        roleTimeTemp: action.roleTimeTemp
      }
    case actions.ROLE_TIME_ADMIN:
      return {
        ...state, 
        roleTimeAdmin: action.roleTimeAdmin
      }
    case actions.ROLE_CUST_SUPP:
      return {
        ...state, 
        roleCustSuppAdmin: action.roleCustSuppAdmin
      }
    case actions.ROLE_CUST_SUPP_ADMIN:
      return {
        ...state, 
        roleCustSuppAdmin: action.roleCustSuppAdmin
      }
    case actions.ROLE_EMP:
      return {
        ...state, 
        roleEmp: action.roleEmp
      }
    case actions.ROLE_EMP_TL:
      return {
        ...state, 
        roleEmpTl: action.roleEmpTl
      }
    case actions.ROLE_EMP_ADMIN:
      return {
        ...state, 
        roleEmpAdmin: action.roleEmpAdmin
      }
    case actions.ROLE_EMP_DATA:
      return {
        ...state, 
        roleEmpData: action.roleEmpData
      }          
    case actions.ROLE_AUDITING:
      return {
        ...state, 
        roleAuditing: action.roleAuditing
      }
    case actions.ROLE_AUDITING_ADMIN:
      return {
        ...state, 
        roleAuditingAdmin: action.roleAuditingAdmin
      }      
    case actions.ROLE_FRA_OB_OBSERVER:
      return {
        ...state, 
        roleFraObObserver: action.roleFraObObserver
      }
    case actions.ROLE_ADMIN:
      return {
        ...state, 
        roleAdmin: action.roleAdmin
      }
    case actions.ROLE_SUPERUSER:
      return {
        ...state, 
        roleSuperuser: action.roleSuperuser
      }         
    case actions.ROLE_NO_FRA_ROLE:
      return {
        ...state, 
        roleNoFraRole: action.roleeNoFraRole
      }
    case actions.ROLE_NO_CS_ROLE:
      return {
        ...state, 
        roleNoCsRole: action.roleNoCsRole
      }
    case actions.ROLE_DB_REPLICATOR:
      return {
        ...state, 
        roleDbReplicator: action.roleDbReplicator
      }
    case actions.ROLE_DB_REPLICATOR_ADMIN:
      return {
        ...state, 
        roleDbReplicatorAdmin: action.roleDbReplicatorAdmin
      }
    case actions.ROLE_NO_COMP_ROLE:
      return {
        ...state, 
        roleNoCompRole: action.roleeNoCompRole
      }
    case actions.ROLE_CUST_SUPP_STATISTICS:
      return {
        ...state, 
        roleCustSuppStatistics: action.roleCustSuppStatistics
      }
    case actions.ROLE_TRANSPARENCY_ADMIN:
      return {
        ...state, 
        roleTransparencyAdmin: action.roleTransparencyAdmin
      }
    case actions.ROLE_TRANSPARENCY:
      return {
        ...state, 
        roleTransparency: action.roleTransparency
      }
    case actions.ROLE_DATAMANAGER:
      return {
        ...state, 
        roleDatamanager: action.roleDatamanager
      }
    case actions.ROLE_DATAMANAGER_ADMIN:
      return {
        ...state, 
        roleDatamanagerAdmin: action.roleDatamanagerAdmin
      }
    case actions.ROLE_CLEARING_ADMIN:
      return {
        ...state, 
        roleClearingAdmin: action.roleClearingAdmin
      }
    case actions.ROLE_CLEARING:
      return {
        ...state, 
        roleClearing: action.roleClearing
      }
    case actions.ROLE_CLEARING_SDI_ADMIN:
      return {
        ...state, 
        roleClearingSdiAdmin: action.roleClearingSdiAdmin
      }
    case actions.ROLE_CLEARING_SDI:
      return {
        ...state, 
        roleeClearingSdi: action.roleeClearingSdi
      }
    case actions.ROLE_FRA_OPERATOR:
      return {
        ...state, 
        roleFraOperator: action.roleFraOperator
      }
    case actions.ROLE_FRA_OB_ADMIN:
      return {
        ...state, 
        roleFraObAdmin: action.roleFraObAdmin
      }
    case actions.ROLE_CONSERVATION_ADMIN:
      return {
        ...state, 
        roleConservationAdmin: action.roleConservationAdmin
      }

    default:        
      return state
  } 
}

export default  currentRoles;